<template>
<footer class="site-footer">
  <div class="container footer-inner">
    <div class="footer-brand">
      <img src="@/assets/images/logo.png" :alt="$t('site.copy291')" loading="lazy">
      <div>
        <p class="footer-name">{{ $t('site.copy292') }}</p>
        <p class="footer-slogan">{{ $t('site.copy293') }}</p>
      </div>
    </div>
  </div>
  <div class="container footer-bottom">
    <p>{{ $t('site.copy303') }}</p>
    <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener">蒙ICP备2026002238号-1</a>
    <p>{{ $t('site.copy304') }}</p>
  </div>
</footer>
</template>
<script>
export default { name: 'SiteFooter' }
</script>



// WEBPACK FOOTER //
// src/components/footer/index.vue